<template>
  <v-layout row wrap mb-4 pa-4>
    <case-header-new></case-header-new>
    <v-flex xs12 v-if="dataReady">
      <v-layout style="background:white !important" class="px-4 py-4 mb-0 elevation-2 rounded-3">
        <v-layout row wrap>
          <v-flex xs12>
            <h2 class="mb-1">Related {{ relatedCaseTypeName }} Cases</h2>
            <p>View all related {{relatedCaseTypeName}} cases for the selected {{currentCaseTypeName}} case.</p>
          </v-flex>
          <v-flex xs12>
            <bucket-table
              ref="bucketTable"
              :dataProvider="dataProvider"
              :dataSearcher="dataSearcher"
              :relationData="relationData"
              :selectedField="selectedField"
              :currentFilter="currentFilter"
              :show-statistics="false">
            </bucket-table>
          </v-flex>
          <v-flex xs12>
            <v-btn
              v-if="hasPermission('Create')"
              @click="createCase()"
              color="success">
              Create {{relatedCaseTypeName}}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import CaseHeaderNew from "@/components/cases/case-edit/CaseHeaderNew.vue"
import DataProvider from "@/components/buckets/bucket-providers/BucketDataProviderRelations.js"
import BucketTable from "@/components/buckets/BucketTable.vue"
import Helpers from "@/helpers.js"
import Vue from 'vue'
import { mapState } from "vuex"
const DataSearcher = DataProvider
export default {
  name: "case-relations",
  components: { CaseHeaderNew, BucketTable },
  props: {
    dataProvider: {
      type: Object,
      default: function() {
        return DataProvider
      }
    },
    dataSearcher: {
      type: Object,
      default: function() {
        return DataSearcher
      }
    }
  },
  data: () => ({
    selectedField: "all_fields",
    relationData: {},
    dataReady: false,
    currentFilter: {
      active: false,
      field: "all_fields",
      term: "",
      itemCount: 0,
      page: 1,
      prevPage: 1,
      currentPage: 1
    }
  }),
  mounted() {
    if (this.$store && this.currentCase) {
      this.$store.dispatch("setPageTitle", `${this.currentCase.caseType} - ${this.currentCase.title}`)
    }
  }, 
  watch: {
    currentRelationType() { this.loadData() },
    currentCaseId() { this.loadData() },
    currentCase() { this.loadData() }
  },
  computed: {
    ...mapState({
      caseTypes: state => state.caseTypes.all,
      currentCase: state => state.cases.currentlySelected.case,
      currentUser: state => {
        const me = (state.currentUser && state.currentUser.me) || {}
        const accountId = state.currentUser && state.currentUser.account && state.currentUser.account.id
        return Object.assign({}, me, { account: { id: accountId } })
      },
      permissions: state => state.ui.grantedPermissions,
      isLoading: state => state.cases.currentlySelected.loading,
      currentCaseId: state => state.cbroute.params.case_id,
      currentRelationType: state => state.cbroute.params.related_type,
      currentViewers: state => state.cases.currentlySelected.viewedBy
    }),
    currentCaseType() {
      if (!this.caseTypes || !this.currentCase) {
        return undefined
      }
      return this.caseTypes.find(ct => ct.id === this.currentCase.caseTypeId)
    },
    relatedCaseType() {
      if (!this.caseTypes) {
        return undefined
      }
      return this.caseTypes.find(ct => ct.code === this.currentRelationType)
    },
    relatedCaseTypeName() {
      return Helpers.caseTypeName(this.relatedCaseType)
    },
    currentCaseTypeName() {
      return this.currentCaseType ? Helpers.caseTypeName(this.currentCaseType) : ""
    }
  },
  created() {
    this.dataProvider.store = Vue.store
    this.dataProvider.initialise()
    this.dataSearcher.store = Vue.store
  },
  methods: {
    hasPermission(permission) {
      if (this.currentUser.isAccountAdmin) { return true }
      return Helpers.hasPermission(this.permissions, permission, this.currentRelationType)
    },
    createCase() {
      if (!this.caseTypes) {
        return
      }
      const type = this.caseTypes.find((currentType) => (currentType.code === this.currentRelationType))
      if (!type) {
        return
      }
      this.$store.dispatch("prepareNewCaseRelations")
      if (this.$router) {
        this.$router.push({
          name: "CaseNew",
          params: { case_type_id: type.id }
        })
      }
    },
    async loadData() {
      this.dataReady = false
      if (!this.caseTypes || !this.currentCase || !this.currentRelationType) {
        return
      }
      const relatedCaseType = this.caseTypes.find((currentType) => (currentType.code === this.currentRelationType))
      const currentCaseType = this.caseTypes.find((currentType) => (currentType.name === this.currentCase.caseType))
      if (!relatedCaseType || !currentCaseType || !currentCaseType.relationships) {
        return
      }
      const relationship = currentCaseType.relationships.find((currentRelation) => (currentRelation.toId === relatedCaseType.id))
      if (relationship) {
        relationship.relatedCaseId = this.currentCaseId
        this.relationData = { caseTypeName: this.currentRelationType, relationship: relationship }
        this.dataReady = true
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    const state = Vue.store.state
    const me = (state.currentUser && state.currentUser.me) || {}
    const accountId = state.currentUser && state.currentUser.account && state.currentUser.account.id
    const currentUser = Object.assign({}, me, { account: { id: accountId } })
    Vue.store.dispatch("unsubscribeToCaseChannelV2", { caseId: from.params.case_id, currentUser: currentUser })
    next()
  },
  beforeRouteEnter(to, from, next) {
    const state = Vue.store.state
    const me = (state.currentUser && state.currentUser.me) || {}
    const accountId = state.currentUser && state.currentUser.account && state.currentUser.account.id
    const currentUser = Object.assign({}, me, { account: { id: accountId } })
    Vue.store.dispatch("subscribeToCaseChannelV2", { caseId: to.params.case_id, currentUser })
    next()
  }
}
</script>
